import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.986 11.64V4.826c2.49 1.138 4.419 2.238 6.7 3.423-1.882 1.014-4.21 2.151-6.7 3.391M23.864 1.436c-.43-.55-1.162-.977-1.941-1.119-2.291-.422-16.584-.423-18.874 0a3.36 3.36 0 0 0-1.66.817C-.625 2.95.006 12.69.491 14.269c.205.683.469 1.176.801 1.5.428.427 1.015.72 1.688.853 1.887.379 11.605.59 18.903.057a3.3 3.3 0 0 0 1.737-.864c1.862-1.809 1.735-12.097.244-14.379"
    }, null, -1)
  ]))]))
}
export default { render: render }